$(window).on('load', function() {
    $(".menu-bar").click(function () {
        $('.menu-side').addClass("active");
        $('body').addClass("tour-demo-new-body-active");
        $('.menu').removeClass("on");
    });
    $(".menu-side .close").click(function () {
        $('.menu-side').removeClass("active");
        $('body').removeClass("tour-demo-new-body-active");
        $('body').removeClass("open-menu");
    });

    $(document).ready(function () {
        $(".header-link--items.link-brands").click(function () {
            $(".header-link--items.link-brands").toggleClass("active");
        });
    });
});



// footer from placeholder add
(function () {
  var container = document.querySelector('.footer-subscribe-form'); // wraps the CC embed
  if (!container) return;

  function applyPlaceholder(input) {
    if (!input || input.dataset.placeholderApplied) return;
    input.setAttribute('placeholder', 'you@email.com');
    input.dataset.placeholderApplied = 'true';
  }

  // In case it's already loaded
  applyPlaceholder(container.querySelector('input[name="email_address"]'));

  // Watch for Constant Contact injecting the form asynchronously
  var observer = new MutationObserver(function () {
    var input = container.querySelector('input[name="email_address"]');
    if (input) {
      applyPlaceholder(input);
    }
  });

  observer.observe(container, { childList: true, subtree: true });
})();